class Lineup {
  constructor () {
    this.tabAll = null;
    this.tabMovie = null;
    this.tabAnime = null;
    this.tabCharactor = null;
    this.tabSports = null;
    this.tabTalent = null;
    this.contentItem = false;
    this.movie = false;
    this.anime = false;
    this.charactor = false;
    this.sports = false;
    this.talent = false;
    this.isMobile = false;
  }

  init () {
    this.tabAll = document.querySelector('.js-tabAll');
    this.tabMovie = document.querySelector('.js-tabMovie');
    this.tabAnime = document.querySelector('.js-tabAnime');
    this.tabCharactor = document.querySelector('.js-tabCharactor');
    this.tabSports = document.querySelector('.js-tabSports');
    this.tabTalent = document.querySelector('.js-tabTalent');

    this.contentItem = document.querySelectorAll('.lineup__contentItemSp');

    this.movie = document.querySelector('.js-movie');
    this.anime = document.querySelector('.js-anime');
    this.charactor = document.querySelector('.js-charactor');
    this.sports = document.querySelector('.js-sports');
    this.talent = document.querySelector('.js-talent');
    if (window.parent.screen.width < 768) {
      this.isMobile = true;
    }
    this.addEvent();
  }

  addEvent () {
    this.tabAll.addEventListener('click', () => {
      this.tabAll.classList.add('lineup__tabItemItem--active');
      this.tabMovie.classList.remove('lineup__tabItemItem--active');
      this.tabAnime.classList.remove('lineup__tabItemItem--active');
      this.tabCharactor.classList.remove('lineup__tabItemItem--active');
      this.tabSports.classList.remove('lineup__tabItemItem--active');
      this.tabTalent.classList.remove('lineup__tabItemItem--active');

      this.movie.classList.add('lineup__content--active');
      this.anime.classList.add('lineup__content--active');
      this.charactor.classList.add('lineup__content--active');
      this.sports.classList.add('lineup__content--active');
      this.talent.classList.add('lineup__content--active');

      if (this.isMobile) {
        for (let i = 0; i < this.contentItem.length; i++) {
        this.contentItem[i].classList.add('lineup__contentItemSp--none');
        }
      }
    })

    this.tabMovie.addEventListener('click', () => {
      this.tabAll.classList.remove('lineup__tabItemItem--active');
      this.tabMovie.classList.add('lineup__tabItemItem--active');
      this.tabAnime.classList.remove('lineup__tabItemItem--active');
      this.tabCharactor.classList.remove('lineup__tabItemItem--active');
      this.tabSports.classList.remove('lineup__tabItemItem--active');
      this.tabTalent.classList.remove('lineup__tabItemItem--active');

      this.movie.classList.add('lineup__content--active');
      this.anime.classList.remove('lineup__content--active');
      this.charactor.classList.remove('lineup__content--active');
      this.sports.classList.remove('lineup__content--active');
      this.talent.classList.remove('lineup__content--active');
      if (this.isMobile) {
        for (let i = 0; i < this.contentItem.length; i++) {
        this.contentItem[i].classList.remove('lineup__contentItemSp--none');
        }
      }
    })

    this.tabAnime.addEventListener('click', () => {
      this.tabAll.classList.remove('lineup__tabItemItem--active');
      this.tabMovie.classList.remove('lineup__tabItemItem--active');
      this.tabAnime.classList.add('lineup__tabItemItem--active');
      this.tabCharactor.classList.remove('lineup__tabItemItem--active');
      this.tabSports.classList.remove('lineup__tabItemItem--active');
      this.tabTalent.classList.remove('lineup__tabItemItem--active');

      this.movie.classList.remove('lineup__content--active');
      this.anime.classList.add('lineup__content--active');
      this.charactor.classList.remove('lineup__content--active');
      this.sports.classList.remove('lineup__content--active');
      this.talent.classList.remove('lineup__content--active');
      if (this.isMobile) {
        for (let i = 0; i < this.contentItem.length; i++) {
        this.contentItem[i].classList.remove('lineup__contentItemSp--none');
        }
      }
    })

    this.tabCharactor.addEventListener('click', () => {
      this.tabAll.classList.remove('lineup__tabItemItem--active');
      this.tabMovie.classList.remove('lineup__tabItemItem--active');
      this.tabAnime.classList.remove('lineup__tabItemItem--active');
      this.tabCharactor.classList.add('lineup__tabItemItem--active');
      this.tabSports.classList.remove('lineup__tabItemItem--active');
      this.tabTalent.classList.remove('lineup__tabItemItem--active');

      this.movie.classList.remove('lineup__content--active');
      this.anime.classList.remove('lineup__content--active');
      this.charactor.classList.add('lineup__content--active');
      this.sports.classList.remove('lineup__content--active');
      this.talent.classList.remove('lineup__content--active');
      if (this.isMobile) {
        for (let i = 0; i < this.contentItem.length; i++) {
        this.contentItem[i].classList.remove('lineup__contentItemSp--none');
        }
      }
    })

    this.tabSports.addEventListener('click', () => {
      this.tabAll.classList.remove('lineup__tabItemItem--active');
      this.tabMovie.classList.remove('lineup__tabItemItem--active');
      this.tabAnime.classList.remove('lineup__tabItemItem--active');
      this.tabCharactor.classList.remove('lineup__tabItemItem--active');
      this.tabSports.classList.add('lineup__tabItemItem--active');
      this.tabTalent.classList.remove('lineup__tabItemItem--active');

      this.movie.classList.remove('lineup__content--active');
      this.anime.classList.remove('lineup__content--active');
      this.charactor.classList.remove('lineup__content--active');
      this.sports.classList.add('lineup__content--active');
      this.talent.classList.remove('lineup__content--active');
      if (this.isMobile) {
        for (let i = 0; i < this.contentItem.length; i++) {
        this.contentItem[i].classList.remove('lineup__contentItemSp--none');
        }
      }
    })

    this.tabTalent.addEventListener('click', () => {
      this.tabAll.classList.remove('lineup__tabItemItem--active');
      this.tabMovie.classList.remove('lineup__tabItemItem--active');
      this.tabAnime.classList.remove('lineup__tabItemItem--active');
      this.tabCharactor.classList.remove('lineup__tabItemItem--active');
      this.tabSports.classList.remove('lineup__tabItemItem--active');
      this.tabTalent.classList.add('lineup__tabItemItem--active');

      this.movie.classList.remove('lineup__content--active');
      this.anime.classList.remove('lineup__content--active');
      this.charactor.classList.remove('lineup__content--active');
      this.sports.classList.remove('lineup__content--active');
      this.talent.classList.add('lineup__content--active');
      if (this.isMobile) {
        for (let i = 0; i < this.contentItem.length; i++) {
        this.contentItem[i].classList.remove('lineup__contentItemSp--none');
        }
      }
    })
  }
};

const lineup = new Lineup();
lineup.init();
